import { useActionMutation } from '@ztechapps/common.hook'
import type { CreateOrderDocumentLinkArgs, DocumentLinkCreated } from '@ztechapps/common.contract'
import { createOrderDocumentLinkQuery } from './graphql'

export type UseCreateOrderDocumentLinkResult = {
  /** Creates a new public link for the order; the token is shown only in this result. */
  mint: (orderId: string) => Promise<DocumentLinkCreated>
}

export const useCreateOrderDocumentLink = (): UseCreateOrderDocumentLinkResult => {
  const [createLink] = useActionMutation<DocumentLinkCreated, CreateOrderDocumentLinkArgs>({
    query: createOrderDocumentLinkQuery,
  })

  return { mint: (orderId) => createLink({ orderId }) }
}
